import accountService from "../services/account";
import notification from "../services/notification";
import auth from "../services/auth";
import router from "../router";

export default {
    namespaced: true,
    state: {
        loading: false,
        errors: null,
        detail: {
            oldpassword: null,
            password: null,
            password_confirmation: null
        }
    },

    mutations: {
        loading(state) {
            state.loading = true;
        },

        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },

        setDetails(state, value) {
            state.detail.oldpassword = value.oldPassword;
            state.detail.password = value.newPassword;
            state.detail.password_confirmation = value.confirmPassword;
        },
        resetErrors(state) {
            state.errors = null;
        },
    },

    getters: {},

    actions: {
        updateDetails: async ({ commit, state }) => {
            commit("loading");

            try {
                let response = await accountService.updateSecurityDetail(
                    state.detail,
                    state.errors = null
                );
                notification.success(response.message);
                commit("loading", false);
                
                // for first time update
                // if (!auth.getHasPasswordUpdated()) {
                    await auth.setHasPasswordUpdated(true);
                    
                // }

                // router.go("/setup/start");
                router.push('/onboarding')
            } catch (errors) {
                commit("errors", errors);
                notification.warning("Oops, something went wrong");
            }
        },
        async resetErrors({ commit }) {
            commit("resetErrors");
        }
    }
};
